import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthResponse } from '../interfaces/authResponse.interface';
import { environment } from '@env/environment';
import { Response } from '@app/core/interfaces/response';
import { WebResponse } from '@app/shared/interfaces/webResponse.interface';

interface ChangePasswordRequest {
  accessToken: string;
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
}

@Injectable({
    providedIn: 'root'
})

export class UserAuthService {
    constructor(
        private httpClient: HttpClient
    ) {}

    validateCognitoTokens(accessToken: string, idToken: string): Observable<AuthResponse> {
      return this.httpClient.post<AuthResponse>(`${environment.apiUrl}/UserAuth/login-with-cognito`, { accessToken, idToken });
    }
    loginUser(username: string, password: string): Observable<AuthResponse> {
        return this.httpClient.post<AuthResponse>(`${environment.apiUrl}/UserAuth/authenticate`, {username, password});
    }

    logoutUser(): Observable<Response> {
        return this.httpClient.get<Response>(`${environment.apiUrl}/UserAuth/logout`);
    }

    forgotPassword(identifier: string): Observable<Response>  {
        return this.httpClient.post<Response>(`${environment.apiUrl}/UserAuth/forgot-password`, { identifier });
    }

    resetPassword(identifier: string, newPassword: string, resetCode: string): Observable<Response>  {
        return this.httpClient.post<Response>(`${environment.apiUrl}/UserAuth/reset-password`, { identifier, newPassword, resetCode });
    }

    changePassword(request: ChangePasswordRequest) {
      return this.httpClient.post<Response>(`${environment.apiUrl}/UserAuth/change-password`, request);
    }

    getNewTokensByRefreshToken(refreshToken: string): Observable<AuthResponse> {
        return this.httpClient.post<AuthResponse>(`${environment.apiUrl}/UserAuth/get-new-tokens-by-refresh-token`, { refreshToken });
    }

    forceChangePassword(userName: string, newPassword: string, session: string): Observable<WebResponse<boolean>> {
      return this.httpClient.post<WebResponse<boolean>>(`${environment.apiUrl}/UserAuth/force-change-password`, { userName, newPassword, session });
    }
}
